module.exports = __webpack_public_path__ + "img/337-50eb4c.png";